import { useCallback } from 'react';
import { SeventhDoorContent } from 'shared/components/SeventhDoorContent';
import { SEVENTH_DOOR_TELEGRAM_CHANNEL_LINK, SEVENTH_GIFT_DOOR_LINK } from 'shared/constants/links';
import { useDoorContent } from 'shared/hooks';
import { EAdventDoorsHashs, TDoor } from 'shared/types/doors';

export const SeventhDoorContentContainer: React.FC<Omit<TDoor, 'onClickBtn'>> = props => {
  const { handleClickBtn, isDoorCompleted } = useDoorContent({
    doorCode: EAdventDoorsHashs.SeventhDoor,
    giftLink: SEVENTH_GIFT_DOOR_LINK,
  });

  const handleOpenTelegramHostsLink = useCallback(() => {
    window.open(SEVENTH_DOOR_TELEGRAM_CHANNEL_LINK, '_blank');
  }, []);

  return (
    <SeventhDoorContent
      onClickBtn={handleOpenTelegramHostsLink}
      secondBtn={{ btnText: 'Забрать стикерпак', onSecondBtn: handleClickBtn }}
      firstBtnClicked={isDoorCompleted}
      {...props}
    />
  );
};
